

<!-- OrderSuccess.svelte -->


<script>

    import { onMount, onDestroy, createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();
    import { fly, fade } from 'svelte/transition';

    import { App } from '@capacitor/app';
    import { Capacitor } from '@capacitor/core';
	
    import { Plugins } from '@capacitor/core';



  let orderDetails = null;
  let backButtonUnlistener;



  

onMount(() => {
  window.scrollTo(0, 0);
	
  const storedResponse = localStorage.getItem('orderResponse');
  if (storedResponse) {
    orderDetails = JSON.parse(storedResponse).order;
    
    // Clean up local storage
    localStorage.removeItem('orderResponse');
    localStorage.removeItem('checkoutResponse');
    localStorage.removeItem(`cart-${orderDetails.category}`);
  }

  // Add Android back button listener if running on a native platform
  if (Capacitor.isNativePlatform()) {
    backButtonUnlistener = App.addListener('backButton', goBack);
  }
});

onDestroy(() => {
  if (backButtonUnlistener) {
    backButtonUnlistener.remove();
  }
});

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  }


    function goBack() {
        dispatch('goToHome');
    }



  function formatTime(timeString) {
    const [hours, minutes] = timeString.split(':');
    const hour = parseInt(hours, 10);
    const minute = parseInt(minutes, 10);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const formattedHour = hour % 12 || 12;
    return `${formattedHour}:${minute.toString().padStart(2, '0')} ${ampm}`;
  }


</script>

<style>

* {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}




  .success-container {
    font-family: 'Roboto', sans-serif;
    color: #333;
    padding: 20px;
    padding-top: calc(20px + env(safe-area-inset-top));
    padding-bottom: calc(90px + env(safe-area-inset-bottom));
    background-color: #f9f9f9;
    min-height: 100vh;
  }

  .success-header {
    text-align: center;
    margin-bottom: 30px;
  }

  .success-icon {
    font-size: 80px;
    color: #4CAF50;
    margin-bottom: 20px;
  }

  h1 {
    font-size: 28px;
    color: #4CAF50;
    margin-bottom: 10px;
  }

  .payment-status {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
    padding: 10px;
    border-radius: 8px;
    background-color: #E8F5E9;
    color: #2E7D32;
  }

  .order-summary, .pickup-summary {
    background-color: white;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  h2 {
    font-size: 22px;
    margin-bottom: 15px;
    color: #2196F3;
  }

  .summary-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    font-size: 16px;
  }

  .item-list {
    margin-top: 15px;
  }

  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #e0e0e0;
  }

  .item:last-child {
    border-bottom: none;
  }

  .item-details {
    flex: 1;
  }

  .item-title {
    font-weight: bold;
  }

  .item-meta {
    font-size: 14px;
    color: #666;
  }

  .item-price {
    font-weight: bold;
  }

  .total {
    font-size: 18px;
    font-weight: bold;
    margin-top: 15px;
    text-align: right;
  }

  .pickup-summary h2 {
    font-size: 22px;
    margin-bottom: 15px;
    color: #2196F3;
  }

  .pickup-details {
    background-color: #E3F2FD;
    border-radius: 8px;
    padding: 15px;
  }

  .pickup-item {
    margin-bottom: 15px;
  }

  .pickup-label {
    font-size: 14px;
    color: #555;
    margin-bottom: 5px;
  }

  .pickup-value {
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }

  .continue-shopping {
    position: fixed;
    bottom: calc(12px + env(safe-area-inset-bottom));
    left: 0;
    right: 0;
    background-color: #2196F3;
    color: white;
    padding: 20px 15px;
    text-align: center;
    text-decoration: none;
    font-weight: bold;
    font-size: 18px;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    transition: background-color 0.3s ease;
  }

  .continue-shopping:hover {
    background-color: #1976D2;
  }

  .confetti {
    position: fixed;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    animation: confetti 5s ease-in-out infinite;
  }

  @keyframes confetti {
    0% { transform: translateY(0) rotate(0deg); opacity: 1; }
    100% { transform: translateY(100vh) rotate(720deg); opacity: 0; }
  }
</style>

<div class="success-container">
  {#each Array(50) as _, i}
    <div 
      class="confetti" 
      style="
        left: {Math.random() * 100}vw; 
        top: -{Math.random() * 20}vh;
        background-color: {['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff'][Math.floor(Math.random() * 6)]};
        animation-delay: -{Math.random() * 5}s;
      "
    ></div>
  {/each}

  <div class="success-header" in:fly="{{ y: -50, duration: 1000 }}">
    <div class="success-icon">🎉</div>
    <h1>Order Successful!</h1>
    <p>Thank you for your purchase. Your order has been confirmed.</p>
  </div>

  {#if orderDetails}
    <div class="payment-status" in:fly="{{ y: 50, duration: 1000, delay: 300 }}">
      Payment ₹{orderDetails.final_price} {orderDetails.payment_type === 'cash' ? 'Cash' : 'Successful'}
    </div>

    <div class="order-summary" in:fly="{{ y: 50, duration: 1000, delay: 600 }}">
      <h2>Order Summary</h2>

      <div class="item-list">
        {#each orderDetails.order_items as item}
          <div class="item">
            <div class="item-details">
              <div class="item-title">{item.product_title}</div>
              <div class="item-meta">
                {item.order_time_unit} {item.order_time_measurement_unit} x {item.quantity}
              </div>
            </div>
            <div class="item-price">₹{item.subtotal}</div>
          </div>
        {/each}
      </div>
      <div class="total">
        Total: ₹{orderDetails.final_price}
      </div>
    </div>

    <div class="pickup-summary" in:fly="{{ y: 50, duration: 1000, delay: 900 }}">
      <h2>Pickup Summary</h2>
      <div class="pickup-details">

        {#if orderDetails.delivery_details && orderDetails.delivery_details.pickup_code}
          <div class="pickup-item">
            <div class="pickup-label">Pickup Code</div>
            <div class="pickup-value">{orderDetails.delivery_details.pickup_code}</div>
          </div>
        {/if}
	  
        <div class="pickup-item">
          <div class="pickup-label">Pickup Date</div>
          <div class="pickup-value">{formatDate(orderDetails.expected_delivery_date)}</div>
        </div>

        <div class="pickup-item">
          <div class="pickup-label">Pickup Time</div>
          <div class="pickup-value">Collect after {formatTime(orderDetails.delivery_time)}</div>
        </div>

        <div class="pickup-item">
          <div class="pickup-label">Pickup Point</div>
          <div class="pickup-value">{orderDetails.delivery_point_details.name}</div>
        </div>
        <div class="pickup-item">
          <div class="pickup-label">Address</div>
          <div class="pickup-value">{orderDetails.delivery_point_details.address}</div>
        </div>
      </div>
    </div>
	
  {/if}

<a href="#" on:click|preventDefault={goBack} class="continue-shopping" in:fade="{{ duration: 1000, delay: 1200 }}">
  Continue Shopping
</a>

</div>